var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth-layout row align-content--center"},[_c('div',{staticClass:"flex xs12 pa-3 flex-center align-content--center"}),_c('div',{staticClass:"flex xs12 pa-3"},[_c('div',{staticClass:"d-flex justify--center"},[_c('va-card',{staticClass:"auth-layout__card"},[_c('div',{staticClass:"pa-3"},[_c('router-view')],1)])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }